import React from "react";
import MixBytesLogo from "../../../../img/about/MixBytes.png";
import { FlexBetweenContainer } from "../../../../containers/FlexBetweenContainer";

export const AuditedSection: React.FC = () => {
  return (
    <FlexBetweenContainer direction="column">
      <h2 className="audited">Audited by</h2>
      <img src={MixBytesLogo} width="200" alt={"MixBytes auditor logo"} />
    </FlexBetweenContainer>
  );
};
